<template>
  <!--  {{ isExpand }} -->
  <!--    {{ chatContentArrayMail }}-->
  <div :style="{ width: smallAIWidth,height: smallAIHeight}" class="ai-box">
    <div class="ai-top" :style="{height:isExpand?'56px':'39px'}">
      <div class="left">
        <span style="display: inline-block;vertical-align:middle;">
          <img style="width: 24px;height: 24px;" :src="aiIcon"/></span>
        <span style="margin-left: 10px;">{{ $t('ai.email.title') }}</span>
      </div>
      <div class="right">
        <img v-if="!isExpand" style="width: 16px;height: 16px;cursor: pointer;margin-right: 15px;"
             @click="handleAmplify"
             src="@/assets/AI/big.png"/>
        <img v-else style="width: 16px;height: 16px;cursor: pointer;margin-right: 15px;" @click="handleAmplify"
             src="@/assets/AI/small.png"/>
        <img style="width: 16px;height: 16px;cursor: pointer" @click="handleCloseAIChat"
             src="@/assets/AI/right-row.png"/>
      </div>
    </div>
    <!--    <div class="chat-content">-->
    <!--      <div v-if="isExpand">-->
    <!--        1-->
    <!--      </div>-->
    <!--      <div v-else>-->
    <!--        <el-input-->
    <!--            v-model="textareaEmailContent"-->
    <!--            style="width: 100%;height: 100%;"-->
    <!--            :autosize="{ minRows: 5, maxRows: 5 }"-->
    <!--            type="textarea"-->
    <!--            @focus="handleFocus"-->
    <!--            :placeholder="textareaEmailContentPlaceholder"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
    <div v-if="isExpand" class="chat-content" ref="messageContainer" @scroll="handleClickScroll">
      <div class="first_title_email">
        <VMarkdownView
            class="content"
            :mode="mode"
            :content="displayContent"
        >
        </VMarkdownView>
      </div>
      <template v-if="isFirstOpen">
        <template v-if="!enterDetailLoading">
          <template v-for="(item,index) in chatContentArrayMail" :key="item">
            <ChatAI :item="item" @refresh="handleClickReplay"
                    :chatContentArrayMail="chatContentArrayMail"
                    @closeCopy="handleCloseAIChat"
                    :isSelectModel="isSelectModel"
                    :isEmailAI="true"
                    @insertContentToTinyMCE="handleInsertContentToTinyMCE"
            >
              <!-- 判断是否展示 createTime -->
              <template #time v-if="shouldShowCreateTime(index)">
                <div class="time">
                  {{ item.createTime }}
                </div>
              </template>
            </ChatAI>
          </template>
        </template>
        <template v-else>
          <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div v-loading="enterDetailLoading"></div>
          </div>
        </template>
      </template>
      <template v-else>
        <!--        <div-->
        <!--            style="width: 100%;height: 100%;padding: 40px;display: flex;justify-content: center;flex-direction: column;align-items: center">-->
        <!--          <div style="margin-bottom: 15px">-->
        <!--            <img-->
        <!--                style="height: 60px; width: 60px"-->
        <!--                src="@/assets/chat.png"-->
        <!--                class="icon"-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div class="btn-text-ai">{{ $t('common.ai.hi') }}</div>-->
        <!--          <div class="btn-text-ai">{{ $t('common.ai.des') }}</div>-->
        <!--        </div>-->
      </template>
    </div>
    <div style="display: flex;flex-direction: column;">
      <!--      重复： {{ preAIChatData }}-->
      <!--      所有： {{ chatContentArrayMail }}-->
      <template v-if="isExpand">
        <!--        <div v-if="isFirstOpen" class="ai-tools">-->
        <!--          <div style="display: flex;justify-content: space-between">-->
        <!--            <el-button type="info" :class="['btn-tool',isSelectModel?'select_r1':'unselect_r1']" round-->
        <!--                       @click="handleClickChangeModel">-->
        <!--              <template #icon>-->
        <!--                <img src="@/assets/AI/sdsk.svg" style="width: 16px;height: 16px;margin-right: 10px">-->
        <!--              </template>-->
        <!--              <span style="font-size: 13px !important;">{{ $t('common.deep.think') }}</span>-->
        <!--            </el-button>-->
        <!--            <el-button type="info" class="btn-tool" round @click="handleClickFixMistakes">-->
        <!--              <template #icon>-->
        <!--                <img src="@/assets/AI/change-error.png" style="width: 16px;height: 16px">-->
        <!--              </template>-->
        <!--              <span style="font-size: 13px !important;">{{ $t('common.lang.current.error') }}</span>-->
        <!--            </el-button>-->
        <!--            <el-button type="info" class="btn-tool" round @click="handleClickReplay('')">-->
        <!--              <template #icon>-->
        <!--                <img src="@/assets/AI/refresh.png" style="width: 16px;height: 16px">-->
        <!--              </template>-->
        <!--              <span style="font-size: 13px !important;">{{ $t('common.repeat.answer') }}</span>-->
        <!--            </el-button>-->
        <!--          </div>-->
        <!--          <div style="margin-top: 10px;display: flex;justify-content: space-between">-->
        <!--            <el-select-->
        <!--                v-model="valueText"-->
        <!--                :placeholder="$t('common.ai.text')"-->
        <!--                :teleported="false"-->
        <!--                class="btn-tool-sp"-->
        <!--                default-first-option-->
        <!--                @change="handleClickChangeSelect"-->
        <!--            >-->
        <!--              <template #prefix>-->
        <!--                <img class="tag_img" src="@/assets/AI/text.png"/>-->
        <!--              </template>-->
        <!--              <el-option-->
        <!--                  v-for="item in optionsText"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--                <div style="display: flex;align-items: center;flex-direction: row">-->
        <!--                  &lt;!&ndash;                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/text.png"/>&ndash;&gt;-->
        <!--                  <div>{{ item.label }}</div>-->
        <!--                </div>-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--            <el-select v-model="valueTone"-->
        <!--                       :placeholder="$t('common.ai.tone')"-->
        <!--                       :teleported="false"-->
        <!--                       class="btn-tool-sp"-->
        <!--                       default-first-option-->
        <!--                       @change="handleClickChangeSelect"-->
        <!--            >-->
        <!--              <template #prefix>-->
        <!--                <img class="tag_img" src="@/assets/AI/say.png"/>-->
        <!--              </template>-->
        <!--              <el-option-->
        <!--                  v-for="item in optionsTone"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--                <div style="display: flex;align-items: center;flex-direction: row;">-->
        <!--                  &lt;!&ndash;                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/say.png"/>&ndash;&gt;-->
        <!--                  <span>{{ item.label }}</span>-->
        <!--                </div>-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--            <el-select v-model="valueLang" :placeholder="$t('common.ai.lang')" :teleported="false" class="btn-tool-sp"-->
        <!--                       @change="handleClickChangeSelect"-->
        <!--            >-->
        <!--              <template #prefix>-->
        <!--                <img class="tag_img" src="@/assets/AI/lang.png"/>-->
        <!--              </template>-->
        <!--              <el-option-->
        <!--                  v-for="item in optionsLang"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--                <div style="display: flex;align-items: center;flex-direction: row">-->
        <!--                  &lt;!&ndash;                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/lang.png"/>&ndash;&gt;-->
        <!--                  <span>{{ item.label }}</span>-->
        <!--                </div>-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div v-else class="ai-template-text">-->
        <!--          <el-button v-for="item in templateText" :key="item.key" type="info" class="btn-text" round-->
        <!--                     @click="handleClickText(item.value)">-->
        <!--            {{ item.value }}-->
        <!--          </el-button>-->
        <!--        </div>-->
      </template>
      <div class="ai-text">
        <el-input
            v-model="chatText"
            style="width: 100%;resize:none"
            :placeholder="textareaEmailContentPlaceholder"
            show-word-limit
            maxlength="3000"
            type="textarea"
            rows="5"
            :autosize="{minRows:5,maxRows:5}"
            @keydown.enter="handleEnter"
            @focus="handleFocus"
        />
        <!--        @keydown.enter.prevent="handleClickSend(true)"-->
        <div class="btn" v-if="isExpand">
          <div
              :aria-disabled="chatText === '' ? true : false"
              v-if="currentIsCompleted"
              @click="chatText !== '' && handleClickSend(true)"
              :style="{ cursor: chatText === '' ? 'not-allowed' : 'pointer', opacity: chatText === '' ? 0.5 : 1 }"
          >
            <span style="font-size: 12px !important;">{{ $t('common.sent') }}</span>
          </div>
          <div
              v-else
              @click="handleClickStop"
          >
            <span style="font-size: 12px !important;">{{ $t('common.ai.stop') }}</span>
          </div>
          <el-button type="info" :class="['btn-tool',isSelectModel?'select_r1_sp':'unselect_r1_sp']"
                     round
                     @click="handleClickChangeModel">
            <template #icon>
              <img src="@/assets/AI/sdsk.svg" style="width: 16px;height: 16px;margin-right: 10px">
            </template>
            <span style="font-size: 12px !important;">{{ $t('common.deep.think') }}</span>
          </el-button>
          <!--          <div @click="handleCloseAIChat">-->
          <!--            <span style="font-size: 12px !important;">{{ $t('common.close') }}</span>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import ChatAI from "@/components/AI/ChatAI.vue";
import {useStore} from "vuex";
import SSESdk from '@/api/sse'
import ChatAIArray from "@/components/AI/ChatAIArray.vue";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash";
import {isOpenLimit, TIME_OUT} from "@/utils/statusParams";
import dayjs from "dayjs";
import {processChatData} from "@/utils/util";
import {ElMessage} from "element-plus";
import AIPointsWarningPop from "@/components/DiaPops/AIPointsWarningPop.vue";
import {useRoute, useRouter} from "vue-router";
import {i18n} from "@/lang";
import aiIcon from "@/assets/AI/AI@2x.png"
import {VMarkdownView} from "vue3-markdown";
import {Storage} from "@/utils/storage";

const emit = defineEmits(["closeAIChat", "handleAmp", "textFocus", "emailAIInsertContentToTinyMCE"])
const store = useStore()
const router = useRouter()
const route = useRoute()

const userInfo = computed(() => store.state.user.userInfo);
const teamId = computed(() => store.state.email.teamID);
// 模型选择
const isSelectModel = ref(false)

const currentTime = ref(dayjs(new Date()).format('HH:mm:ss'));
const chatText = ref("")
// 对话初始框
const isFirstOpen = ref(false)
// 滚动到底部函数
const messageContainer = ref()

const {smallAIHeight, smallAIWidth, isExpand, currentEmailDetail} = defineProps({
  smallAIHeight: {
    type: String,
    default: '180px'
  },
  smallAIWidth: {
    type: String,
    default: '350px'
  },
  isExpand: {
    type: String,
    default: false,
  },
  currentEmailDetail: {
    type: Object,
    default: () => {
    }
  }
})

// 聊天的内容
const chatContentArrayMail = computed(() => store.state.AI.chatContentArrayMail)
const mode = ref('light')
// 展示时间
const shouldShowCreateTime = (index) => {
  // 第一个 item 始终展示
  if (index === 0) return true;

  // 当前项与前一项的 createTime 比较，不同则展示
  return chatContentArrayMail.value[index].createTime !== chatContentArrayMail.value[index - 1].createTime;
};


const visitableAI = ref(false)
const visitableAIClose = () => {
  visitableAI.value = false
}

const valueText = ref('')
const valueTone = ref('')
const valueLang = ref('')

// 聊天历史记录
const visitableHistory = ref(false)
const visitableHistoryDetail = ref(false)
const visitableSetting = ref(false)
// AI 思考
const isLoadingAIChat = ref(false)
// AI 当前思考是否完成
const isCompletedAIChat = ref(false)
// 记录当前会话重新生成 内容的所有数据
let preAIChatData = ref([])
// 用户是否进行手动滚动
const isUserScrolling = ref(false);
// 发送数据
const associateIdMail = computed(() => store.state.AI.associateIdMail)
// 详情数据
const currentTargetChatMail = computed(() => store.state.AI.currentTargetChatMail)
// 最后一条新的数据 root
const currentLastNewChatMail = computed(() => store.state.AI.currentLastNewChatMail)

// 展示时间
const isShowTime = ref(false)
const handleClickHistory = () => {
  visitableHistory.value = true
}
const close = () => {
  visitableHistory.value = false
}

const closeDetail = () => {
  visitableHistoryDetail.value = false
}

const handleEnter = (event) => {
  if (event.shiftKey) {
    // 允许换行
    return;
  }
  event.preventDefault();
  handleClickSend(true);
};


// 选中的item 详情详
const handleTargetDetail = ref({})
const enterDetailLoading = ref(false)
const handleClickDetail = async (item) => {
  console.log(item, 'item')
  if (!currentIsCompleted.value) {
    ElMessage.warning(i18n.global.t('common.ai.data.message'))
    return
  }
  // 先关闭
  isFirstOpen.value = true
  visitableHistoryDetail.value = false
  await close()
  enterDetailLoading.value = true
  //再进加载数据
  currentIsCompleted.value = true
  handleTargetDetail.value = item
  // 重置 分页缓存的数据
  await localStorage.setItem("pageData", JSON.stringify([]))
  // 重置 列表内容
  await store.commit("AI/setChatContentArrayMail", [])
  await store.commit("AI/setAssociateIdMail", "")
  isShowTime.value = true
  currentTime.value = item.createTime
  await store.dispatch("AI/queryChatByIdApisMail", {
    associateId: item.id,
    parentId: item.parentId ? item.parentId : '0'
  })
  //  将数据整理到 聊天框
  const res = currentTargetChatMail.value.map(item => ({
    ...item,
    isCompletedAIChat: true,
    associateContent: item.associateContent.split('\n\n').join('\n\n>')
  }))
  await store.commit("AI/setChatContentArrayMail", res)
  await store.commit("AI/setAssociateIdMail", item.id)
  // 第一次进入 检查缓存
  const result = Storage.get("AIChatMessage");
  console.log(result, 'result')
  if (!result || result === "null" || result === "undefined" || result === "") {
    const target = {
      associateId: item.id,
      model: isSelectModel.value ? 'high' : 'medium',
      message: item.question,
      parentId: "0",
    }
    await Storage.set("AIChatMessage", target)
  }

  enterDetailLoading.value = false
  // 滚动到最底部
  await nextTick(() => {
    scrollToBottom();
  });
}

const closeSetting = () => {
  visitableSetting.value = false
}

const handleClickSetting = () => {
  visitableSetting.value = true
}

// 本次生成是否完毕？
const currentIsCompleted = ref(true)

// 判断容器是否在底部
const isAtBottom = () => {
  if (!messageContainer.value) return false;
  const {scrollTop, clientHeight, scrollHeight} = messageContainer.value;
  console.log(scrollTop + clientHeight, scrollHeight, ((scrollTop + clientHeight) - scrollHeight), scrollTop + clientHeight >= scrollHeight - 10, 'dddddd')
  return scrollTop + clientHeight >= scrollHeight - 10; // 允许少量误差
};

const allProductList = computed(() => store.state.buystorage.allProductList)
onMounted(async () => {
  if (isEmpty(allProductList.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  }
})

// 存储 sse 对象
const sseClient = ref(null)

async function createSSE(params, item) {
  isCompletedAIChat.value = false;
  const baseUrl = process.env.VUE_APP_BASE_API + "/ai/chat/send";
  const SSE = new SSESdk(baseUrl);
  sseClient.value = SSE;
  // 睡眠 3s 展示loading
  console.log('开始睡眠')
  await new Promise(r => setTimeout(r, 6000))
  console.log('结束睡眠')
  console.log(currentEmailDetail, 'currentEmailDetail.value')
  try {
    const {cc, bcc, to, sendTime, userId, subject, from} = currentEmailDetail
    // 订阅来自服务端的消息
    const payload = {
      ...params,
      type: 2,
      teamId: teamId.value,
      cc,
      bcc,
      to,
      subject,
      userId,
      from,
      sentTime: sendTime,
      createTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
    }
    if (userInfo.value.companyId) {
      payload.companyId = userInfo.value.companyId
    }
    if (route.query.id) {
      payload.mailId = route.query.id
    }
    console.log(payload, 'payloadpayload')
    await sseClient.value.start(payload, 2, async (data) => {
      isLoadingAIChat.value = false;

      const resultData = data.reasoningContent ? {type: 'reasoning', value: data.reasoningContent}
          : data.content ? {type: 'content', value: data.content}
              : null;
      if (resultData) {
        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
          console.log("======p1=======")
          // 重复发送需要先 拼接，然后 获取 详情得到指定分页内容
          const resultPayload = chatContentArrayMail.value.map(it => {
            console.log(it, item, it.id === item.id, 'dddddd')
            if (it.id === item.id) {
              let content = it.content
              let associateContent = it.associateContent
              if (resultData.type === 'reasoning') {
                resultData.value = resultData.value.split('\n\n').join('\n\n>');
                associateContent += resultData.value
              }
              if (resultData.type === 'content') {
                content += resultData.value
              }
              console.log(content, associateContent, 'resultPayload')
              return {
                ...it,
                question: item.question,
                parentAreaCount: parentAreaCountTotal.value,
                isCompletedAIChat: false,
                content: content,
                associateContent: associateContent,
                currentTime: currentTime.value
              }
            } else {
              return it
            }
          })
          // console.log(resultPayload, 'resultPayload')
          // const endResult = resultPayload.map(i => {
          //   if (i.id === item.id) {
          //     return {
          //       ...i,
          //       isCompletedAIChat: true
          //     }
          //   } else {
          //     return {...i}
          //   }
          // })
          // console.log(endResult, 'endResult')
          store.commit("AI/setChatContentArrayMail", resultPayload)
        } else {
          // 非重复发送
          console.log("======p2=======")
          const lastMessage = chatContentArrayMail.value[chatContentArrayMail.value.length - 1];
          if (preAIChatData.value.length === 0) {
            if (resultData.type === 'reasoning') {
              // 实时拼接过程中检测 \n\n，插入 '>'
              resultData.value = resultData.value.split('\n\n').join('\n\n>');
              lastMessage.associateContent = (lastMessage.associateContent || '') + resultData.value;
            }

            if (resultData.type === 'content') {
              lastMessage.content = (lastMessage.content || '') + resultData.value;
            }
          } else {
            const lastContent = chatContentArrayMail.value[chatContentArrayMail.value.length - 1].content;
            const lastContentItem = lastContent[lastContent.length - 1];

            if (resultData.type === 'reasoning') {
              resultData.value = resultData.value.split('\n\n').join('\n\n>');
              lastContentItem.associateContent = (lastContentItem.associateContent || '') + resultData.value;
            }

            if (resultData.type === 'content') {
              lastContentItem.content = (lastContentItem.content || '') + resultData.value;
            }
          }
          await nextTick(() => {
            if (!isUserScrolling.value) {
              scrollToBottom();
            }
          });
        }
      }
    });
    // 等待订阅完成，检查 isCompleted 状态
    await new Promise((resolve, reject) => {
      const checkCompletion = setInterval(() => {
        if (sseClient.value.isCompleted) {
          clearInterval(checkCompletion);
          resolve();
        }
      }, 100);
      // 设置超时防止无限等待
      setTimeout(() => {
        clearInterval(checkCompletion);
        reject(new Error(i18n.global.t('common.ai.computed.timeout')));
      }, 300 * 1000); // 超时 5分钟
    });
  } catch (error) {
    console.log("SSE 连接或处理过程中发生错误:", 'ddddd');
    const result = Storage.get("AIChatMessage");
    let payload = {}
    if (item && item.parentId) {
      payload = {parentId: item.parentId}
      await store.dispatch("AI/getChatDetailListApisParentMail", payload);
      if (item && item.id) {
        const resultPayload = chatContentArrayMail.value.map(it => {
          if (it.id === item.id) {
            return {
              ...chatDetailListParentMail.value[0],
              question: result.message,
              parentAreaCount: parentAreaCountTotal.value,
              isCompletedAIChat: true,
              content: i18n.global.t('common.ai.sse.message.error'),
              associateContent: "",
            }
          } else {
            return it
          }
        })
        await store.commit("AI/setChatContentArrayMail", resultPayload)
      }
    } else {
      chatContentArrayMail.value[chatContentArrayMail.value.length - 1] = {
        ...chatDetailListParentMail.value[0],
        question: result.message,
        parentAreaCount: parentAreaCountTotal.value,
        isCompletedAIChat: true,
        content: i18n.global.t('common.ai.sse.message.error'),
        associateContent: "",
      }
    }
    currentIsCompleted.value = sseClient.value.isCompleted;
    console.log(sseClient.value.isCompleted, 'after completion check');
    isCompletedAIChat.value = true; // 遇到错误时，标记为已完成
  } finally {
    // 更新智能点数数据
    store.dispatch("cloud/queryByUserIdApis");
    if (isStopSSe.value) {
      isStopSSe.value = false
      return
    }
    // 获取详情 并替换 前端数据
    const result = Storage.get("AIChatMessage");
    const messageId = Storage.get("messageIdMail")
    const parentId = item && item.id ? item.id : messageId
    // payload = {parentId: parentId}
    // console.log(payload, 'payload')
    if (item && item.id) {
      // 如果是重新生成的内容则需要获取详情
      const resultPayload = chatContentArrayMail.value.map(it => {
        if (it.id === item.id) {
          return {
            ...it,
            question: result.message,
            isCompletedAIChat: false,
            currentTime: currentTime.value
          }
        } else {
          return it
        }
      })
      await store.commit("AI/setChatContentArrayMail", resultPayload)
    } else {
      chatContentArrayMail.value[chatContentArrayMail.value.length - 1].isCompletedAIChat = false
      // 保证 id 一直为 根的id
      chatContentArrayMail.value[chatContentArrayMail.value.length - 1].id = chatContentArrayMail.value[chatContentArrayMail.value.length - 1].id ? chatContentArrayMail.value[chatContentArrayMail.value.length - 1].id : parentId
    }

    //======= 确保最终状态同步 ========
    await store.dispatch("AI/getRootDataApisMail", {associateId: associateIdMail.value})

    const targetResult = chatContentArrayMail.value.map(i => {
      if (i.id === currentLastNewChatMail.value.id) {
        // store.commit("AI/setCurrentPage", currentLastNewChat.value.childCount + 1)
        return {
          ...currentLastNewChatMail.value,
          associateContent: currentLastNewChatMail.value.associateContent.split('\n\n').join('\n\n>'),
          isCompletedAIChat: true,
          isDetail: true,
        }
      } else {
        return {...i}
      }
    })
    await store.commit("AI/setChatContentArrayMail", targetResult)
    console.log(chatContentArrayMail.value, 'chatContentArrayMail.value')
    // else {
    //   chatContentArrayMail.value[chatContentArrayMail.value.length - 1] = {
    //     ...chatDetailListParentMail.value[0],
    //     question: result.message,
    //     parentAreaCount: parentAreaCountTotal.value,
    //     isCompletedAIChat: true,
    //     content: chatDetailListParentMail.value[0]?.conversation,
    //     associateContent: "",
    //   }
    // }
    // tools 的添加会导致 页面 scroll 高度发生变化，需要继续滚动
    await nextTick(() => {
      if (!isUserScrolling.value) {
        scrollToBottom();
      }
    });
    currentIsCompleted.value = sseClient.value.isCompleted;
    // 展示完毕后，需要获取详情替换数据
    console.log(sseClient.value.isCompleted, 'after completion check');
  }
}

const scrollToBottom = () => {
  if (messageContainer.value) {
    if (!messageContainer.value || isUserScrolling.value) return;
    messageContainer.value.scrollTop = messageContainer.value.scrollHeight - 10;
  }
};

const payload = ref({})
const chatDetailList = computed(() => store.state.AI.chatDetailList)
const chatDetailListParentMail = computed(() => store.state.AI.chatDetailListParentMail)
// 文件存储的空间大小
const spaceSize = computed(() => store.state.cloud.spaceSize)
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const handleClickSend = throttle(async (replay, item) => {
  return new Promise(async (resolve) => {
    console.log(currentIsCompleted.value, 'currentIsCompleteddddddddd', item)
    // 判断 AI 点数 是否收到充足
    if (isOpenLimit) {
      if (spaceSize.value?.freeAiNum >= 0) {
      } else {
        visitableAI.value = true
        return
      }
    }

    if (!currentIsCompleted.value) {
      resolve(); // 直接结束，如果没有完成
      return;
    }
    currentIsCompleted.value = false;
    if (replay) {
      isShowTime.value = true;
      preAIChatData.value = [];
    }
    console.log(associateIdMail, 'associateIdMail')
    // 检查是否需要创建新会话
    if (associateIdMail.value === "") {
      await store.dispatch("AI/createSessionApisMail");
    }

    const messageId = Storage.get("messageIdMail");
    // sse 数据流
    if (replay) {
      currentItem.value = null
      // 不刷新AI内容
      payload.value = {
        associateId: associateIdMail.value || item?.associateIdMail,
        model: isSelectModel.value ? 'high' : 'medium',
        message: chatText.value,
        parentId: 0,
      };
    } else {
      // 刷新AI内容
      const result = Storage.get("AIChatMessage");
      if (result) {
        result.parentId = item && item.id ? item.id : messageId;
        payload.value = result;
        if (item || item && item.id) {
          payload.value.message = item.question;
        }
      } else {
        console.log('第一次进入')
      }
    }

    // 发起sse请求
    createSSE(payload.value, item);

    isFirstOpen.value = true;
    isLoadingAIChat.value = true;
    // 存储指定数据方便再次提交查询
    // if (!isSettingTool.value) {
    await Storage.set("AIChatMessage", payload.value);
    // }
    if (replay) {
      // 开启自动滚动
      isUserScrolling.value = false
      // 普通AI 回复组件
      chatContentArrayMail.value.push({
        question: chatText.value,
        content: "",
        parentId: "0",
        associateContent: "",
        isCompletedAIChat: false,
        currentTime: currentTime.value
      });
      // 重置数据前需要将
      Storage.set("messageIdMail", "0");
    }
    // 清空展示数据
    chatText.value = "";
    await nextTick(() => {
      scrollToBottom();
    });
    resolve(); // 完成时触发 resolve，表示 handleClickSend 执行完毕
  });
}, TIME_OUT);

const parentAreaCountTotal = computed(() => store.state.AI.chatDetailListSettingParentMail.total)
// 点击重新生成的内容
const currentItem = ref(null)
const handleClickReplay = async (item) => {
  if (!currentIsCompleted.value) {
    return
  }
  console.log(item, 'item')

  // 这里需要缓存第一条数据
  const res = JSON.parse(localStorage.getItem("pageData"))
  if (res && res.length > 0) {
    const flag = res.filter(i => i.id === item.id).length
    if (flag >= 1) {
      // 存在
    } else {
      // 不存在
      localStorage.setItem("pageData", JSON.stringify([...res, item]))
    }
  } else {
    localStorage.setItem("pageData", JSON.stringify([item]))
  }

  if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
    console.log('re-start-1')
    item.content = "";
    item.associateContent = "";
    currentItem.value = item
    await handleClickSend(false, item)
  } else {
    console.log('re-start-2')
    isUserScrolling.value = false
    isSettingTool.value = true;
    chatText.value = i18n.global.t('common.chat.text.repeat');
    await handleClickSend(true);
    isSettingTool.value = false;
    chatText.value = "";
  }
}


// 选择模版
const handleClickText = (value) => {
  chatText.value = value + '：';
}


// 结束并保存
const handleClickClose = async (val) => {
  if (!currentIsCompleted.value) {
    return
  }
  currentIsCompleted.value = true
  await store.commit("AI/setChatContentArrayMail", [])
  await store.commit("AI/setAssociateIdMail", "")
  valueTone.value = "";
  valueText.value = "";
  valueLang.value = "";
  isSelectModel.value = false;
  isFirstOpen.value = false
  isShowTime.value = false
  // emit("closeAIChat")
}

const handleCloseAIChat = () => {
  emit("closeAIChat")
}

const handleAmplify = () => {
  emit("handleAmp")
}

// 是否是操作功能
const isSettingTool = ref(false)
// 选择文本
const handleClickChangeSelect = async (val) => {
  if (!currentIsCompleted.value) {
    return
  }
  isSettingTool.value = true
  chatText.value = val
  await handleClickSend(true)
  isSettingTool.value = false
  chatText.value = ""
}


const handleClickFixMistakes = async () => {
  if (!currentIsCompleted.value) {
    return
  }
  isSettingTool.value = true
  chatText.value = i18n.global.t('common.correct.all.error')
  await handleClickSend(true)
  isSettingTool.value = false
  chatText.value = ""
}


const handleClickChangeModel = () => {
  isSelectModel.value = !isSelectModel.value
  payload.value.model = isSelectModel.value ? 'high' : 'medium'
  Storage.set("AIChatMessage", payload.value)
}


const isLoading = ref(false)
const pageNo = computed(() => store.state.AI.currentTargetSettingMail.pageNo)
const total = computed(() => store.state.AI.currentTargetSettingMail.total)
const pageSize = computed(() => store.state.AI.currentTargetSettingMail.pageSize)
// 滚动获取记录详情
const handleClickScroll = () => {
  // 滚动到底部自动开始 自动滚动
  const shouldAutoScroll = isAtBottom();
  if (shouldAutoScroll) {
    isUserScrolling.value = false
    return;
  }
  const {scrollTop, scrollHeight, clientHeight} = messageContainer.value;

  if (!messageContainer.value) return;
  if (!messageContainer.value || isLoading.value) return;
  // 如果用户未滚动到底部，认为是手动滚动
  isUserScrolling.value = scrollTop + clientHeight <= scrollHeight - 10;
  // 判断是否接近底部
  if (scrollHeight - scrollTop <= clientHeight + 50) {
    if (pageNo.value * pageSize.value <= total.value) {
      loadMoreData(); // 加载更多数据
    }
  }
}

const loadMoreData = async () => {
  isLoading.value = true
  await store.commit("AI/setCurrentTargetSetting", {type: "pageNo", value: pageNo.value + 1})
  await store.dispatch("AI/queryChatByIdApisMail", {
    associateId: handleTargetDetail.value.id,
    parentId: handleTargetDetail.value.parentId ? handleTargetDetail.value.parentId : '0'
  })
  const res = currentTargetChatMail.value.map(item => ({
    ...item,
    isCompletedAIChat: true,
    associateContent: item.associateContent.split('\n\n').join('\n\n>')
  }))
  await store.commit("AI/setChatContentArrayMail", res)
  await store.commit("AI/setAssociateIdMail", currentTargetChatMail.value[0].associateId)
}


/**
 * AI 停止对话
 */
const isStopSSe = ref(false)
const handleClickStop = async () => {
  console.log('stop')
  if (sseClient.value) {
    const target = chatContentArrayMail.value[chatContentArrayMail.value.length - 1]
    let targetChatItem = chatContentArrayMail.value[chatContentArrayMail.value.length - 1]

    const result = Storage.get("AIChatMessage");
    const messageId = Storage.get("messageIdMail")
    const parentIdRes = currentItem.value && currentItem.value.id ? currentItem.value.id : messageId
    if (currentItem.value !== null) {
      //   指定项重新生成
      targetChatItem = currentItem.value
    }
    const {content, associateContent, question, parentId} = targetChatItem
    let payload = {
      associateId: associateIdMail.value,
      associateContent: associateContent ? associateContent : target.associateContent,
      content: content ? content : target.content,
      question: question,
      parentId: parentId,
    }
    if (currentItem.value !== null) {
      payload.parentId = parentIdRes
    }
    console.log(targetChatItem, currentItem.value, 'targetChatItem')
    if (payload.content === "" && payload.associateContent === "") {
      payload.content = " ";
      payload.associateContent = " ";
    }
    //   将最后一条断开的数据进行存储
    await store.dispatch("AI/closeAIApis", payload)
    // 更新状态
    await store.dispatch("AI/getRootDataApisMail", {associateId: associateIdMail.value})
    // payload = {parentId: parentId}
    // console.log(payload, 'payload')
    if (currentItem.value && currentItem.value.id) {
      console.log('=====1')
      // 如果是重新生成的内容则需要获取详情
      const resultPayload = chatContentArrayMail.value.map(it => {
        if (it.id === currentLastNewChatMail.value.id) {
          return {
            ...it,
            question: result.message,
            isCompletedAIChat: false,
            currentTime: currentTime.value
          }
        } else {
          return it
        }
      })
      await store.commit("AI/setChatContentArrayMail", resultPayload)
    } else {
      // 生成一条数据被中断 加载完成了
      if (chatContentArrayMail.value[chatContentArrayMail.value.length - 1].content !== '' || chatContentArrayMail.value[chatContentArrayMail.value.length - 1].associateContent !== '') {
        console.log('=====2', chatContentArrayMail.value, currentLastNewChatMail.value.id, currentLastNewChatMail.value)
        console.log(chatContentArrayMail.value)
        chatContentArrayMail.value[chatContentArrayMail.value.length - 1].isCompletedAIChat = false
        // 保证 id 一直为 根的id
        chatContentArrayMail.value[chatContentArrayMail.value.length - 1].id = currentLastNewChatMail.value.id
      } else {
        // 没有加载完成
        console.log('=====3', chatContentArrayMail.value, currentLastNewChatMail.value.id, currentLastNewChatMail.value)
        chatContentArrayMail.value.pop()
      }
    }


    const targetResult = chatContentArrayMail.value.map(i => {
      if (i.id === currentLastNewChatMail.value.id) {
        // store.commit("AI/setCurrentPage", currentLastNewChat.value.childCount + 1)
        return {
          ...currentLastNewChatMail.value,
          associateContent: currentLastNewChatMail.value.associateContent.split('\n\n').join('\n\n>'),
          isCompletedAIChat: true,
          isDetail: true,
        }
      } else {
        return {...i}
      }
    })
    await store.commit("AI/setChatContentArrayMail", targetResult)

    console.log(targetResult, 'targetResult')
    sseClient.value.pause(); // 断开 SSE
    sseClient.value.isCompleted = true; // 标记完成，防止重连
    isCompletedAIChat.value = true
    currentIsCompleted.value = true
    isStopSSe.value = true
  }
}


// 重启服务
// const handleClickRestart = () => {
//   if (sseClient.value) {
//     // chatContentArrayMail.value[chatContentArrayMail.value.length - 1].isCompletedAIChat = false
//     sseClient.value.resume("message", (data) => {
//       console.log("恢复后收到数据：", data);
//     });
//   }
// }

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};

const toBuy = async () => {
  // 关闭AI
  await handleCloseAIChat()
  //   购买AI
  // const findTarget = allProductList.value.find(item => item.productSort === 4)
  // const {id, productSort} = findTarget
  // router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: 1}})
  openNewTab('/personal/aiDetails')
}

const textareaEmailContentPlaceholder = ref(`${i18n.global.t('common.ai.hi.email')}${i18n.global.t('common.ai.des')}`)
const handleFocus = () => {
  emit("textFocus")
}

const handleInsertContentToTinyMCE = (html) => {
  emit('emailAIInsertContentToTinyMCE', html)
}

const displayContent = ref('')
let timer = null
let index = 0
watch(
    () => isExpand,
    (newValue) => {
      console.log(newValue, 'newValue')

      // ✅ 收起时：清理状态
      if (!newValue) {
        clearInterval(timer)
        timer = null
        index = 0
        displayContent.value = ''
        return
      }

      // ✅ 展开前：防止重复启动
      if (timer) return

      timer = setInterval(() => {
        const fullText = textareaEmailContentPlaceholder.value

        if (index < fullText.length) {
          displayContent.value += fullText[index]
          index++
        } else {
          clearInterval(timer)
          timer = null
        }
      }, 30)
    }
    , {once: true})


onBeforeUnmount(() => {
  clearInterval(timer)
})

</script>
<style lang="less" scoped>
@import "index.less";

.first_title_email {
  //margin-top: 20px;
  max-width: 66%;
  width: auto;
  font-size: 14px !important;
  margin-right: auto;

  .content {
    font-size: 14px !important;
    border-radius: 4px !important;
    background: #EFEFEF !important;
    padding: 10px 20px 10px 20px !important;

    & > p {
      font-size: 14px;
    }
  }
}
</style>